export default __webpack_public_path__ + "static/media/V730_CoC.6cc81ef3.pdf";